const getCustomFontPairsToCreate = (initialCustomFontPairs, currentCustomFontPairs) => {
  const initialCustomFontPairsIdsSet = new Set(initialCustomFontPairs.map((p) => p.id));
  return currentCustomFontPairs.filter((pair) => !initialCustomFontPairsIdsSet.has(pair.id));
};

export default getCustomFontPairsToCreate;
